import React, { useEffect } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import type { Admin, UpdateAdminRequest } from '../types/admin.types';

const { Option } = Select;

interface EditAdminModalProps {
    open: boolean;
    loading: boolean;
    admin: Admin | null;
    roles: any[];
    loadingRoles: boolean;
    onCancel: () => void;
    onSubmit: (id: string, values: UpdateAdminRequest) => void;
}

export const EditAdminModal: React.FC<EditAdminModalProps> = ({
    open,
    loading,
    admin,
    roles,
    loadingRoles,
    onCancel,
    onSubmit
}) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (admin && open) {
            form.setFieldsValue({
                email: admin.email,
                name: admin.name,
                role_id: admin.roles?.[0]?.id || null
            });
        }
    }, [admin, open, form]);

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    const handleOk = () => {
        form.submit();
    };

    const handleFinish = (values: UpdateAdminRequest) => {
        if (admin) {
            onSubmit(admin.id, values);
        }
    };

    return (
        <Modal
            title="Edit Admin"
            open={open}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item name="name" label="Name" rules={[{ required: false }]}>
                    <Input placeholder="Admin Name (Optional)" />
                </Form.Item>
                <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
                    <Input />
                </Form.Item>
                <Form.Item
                    name="role_id"
                    label="Role"
                    rules={[{ required: true, message: 'Please select a role' }]}
                >
                    <Select loading={loadingRoles} placeholder="Select role">
                        {(roles || []).map((r: any) => (
                            <Option key={r.id} value={r.id}>
                                {r.display_name} ({r.name})
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};
